import { Component, h } from 'preact'
import axios from 'axios'
import HappyFace from '../../preact-components/topic-helpfulness/assets/happy.js'
import ConfusedFace from '../../preact-components/topic-helpfulness/assets/confused.js'
import WearyFace from '../../preact-components/topic-helpfulness/assets/weary.js'

type Colors = 'green' | 'orange' | 'red'

const getColor = (percentage: number): Colors => {
  if (percentage < 40) {
    return 'red'
  } else if (percentage < 70) {
    return 'orange'
  }
  return 'green'
}
interface Props {
  topicId: string
}

interface State {
  helpfulnessScore: {
    helpful: number,
    neutral: number,
    nothelpful: number
  },
  percentage: number,
  color: Colors,
  isVisible: boolean
}

class ContentHelpfulnessPerformance extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      helpfulnessScore: {
        helpful: 0,
        neutral: 0,
        nothelpful: 0
      },
      percentage: 0,
      color: 'green',
      isVisible: false
    }
  }

  async componentDidMount () {
    const { data } = await axios.get('/helpfulness/performanceWidget', {
      params: {
        topicId: this.props.topicId
      },
      validateStatus: (state: number) => {
        return (state >= 200 && state < 300) || state === 403
      }
    })
    if (!data || !data.score) {
      return
    }

    const total = Object.keys(data.score).reduce(function (result, options) {
      return result + parseInt(data.score[options])
    }, 0)

    const percentage = total !== 0 ? Math.round(data.score.helpful / total * 100) : 0

    this.setState({
      helpfulnessScore: data.score,
      isVisible: Object.keys(data.score).length > 0,
      percentage: percentage,
      color: getColor(percentage)
    })
  }

  render (props: Props, { helpfulnessScore, color, percentage, isVisible }: State) {
    if (!isVisible) {
      return null
    }

    let { helpful, neutral, nothelpful } = helpfulnessScore

    return (
      <div className='panel panel-default content-helpfulness_performance-wrapper'>
        <div className='panel-heading'>
          <h3 className='panel-title'>Content helpfulness performance</h3>
        </div>

        <div className='panel-body content-helpfulness_performance-body'>
          <span className={`content-helpfulness_performance-score ${color}`} data-score={percentage}>Score {percentage}%</span>
          <span className='topic-helpfulness_performance-options'>
            <HappyFace />
            <span className='content-helpfulness_performance-number qa-topic-helpful'>{helpful}</span>
          </span>
          <span className='topic-helpfulness_performance-options'>
            <ConfusedFace />
            <span className='content-helpfulness_performance-number qa-topic-neutral'>{neutral}</span>
          </span>
          <span className='topic-helpfulness_performance-options'>
            <WearyFace />
            <span className='content-helpfulness_performance-number qa-topic-notHelpful'>{nothelpful}</span>
          </span>
        </div>
      </div>
    )
  }
}

export default ContentHelpfulnessPerformance
